import { config } from "@/config/base";

import AvatarMenu from "@/components/layout/header/avatar";

import Logout from "./logout";
import Messages from "./messages";
import Notifications from "./notifications";
import Settings from "./settings";
import { useEffect, useRef, useState } from "react";
import { Menu, X } from "lucide-react";
import RoleDropdown from "./RoleDropdown";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement | null>(null);
  const buttonRef = useRef<HTMLButtonElement | null>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node;

      if (
        menuRef.current &&
        !menuRef.current.contains(target) &&
        buttonRef.current &&
        !buttonRef.current.contains(target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="flex h-[70px] w-full items-center bg-secondary px-6">
      <div className="">
        <img src={config.logo} alt="" width={165} />
      </div>
      <div className="ms-auto flex items-center">
         <RoleDropdown />
        <AvatarMenu />
      </div>

      <div className="ms-5 hidden lg:flex items-center gap-x-5">
        <Notifications />
        <Messages />
        <Settings />
        <Logout />
      </div>

      <div className="relative lg:hidden">
        {/* دکمه همبرگری */}
        <button
          ref={buttonRef}
          onClick={() => setIsOpen(!isOpen)}
          className="p-2 ms-4 text-white"
        >
          {isOpen ? <X size={20} /> : <Menu size={20} />}
        </button>

        <div
          ref={menuRef}
          className={`absolute z-40 right-2 top-full rounded-md border border-gray-300 bg-white shadow-md p-3 flex flex-col gap-3 text-sm
    transform transition-all duration-300 ease-in-out origin-top-right
    ${isOpen ? "opacity-100 scale-y-100" : "opacity-0 scale-y-0 pointer-events-none"}
  `}
          style={{ transformOrigin: "top right" }}
        >

          <Messages />
          <Logout />
        </div>


      </div>
    </div>
  );
};
export default Header;
